module.exports = __webpack_public_path__ + "static/servingEveryone-9297d2836eb4d7b65b4e017627a6eeef.png";